import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { GridStrategySpec } from "./spec";

/**
 * Board size is the only knob grid-strategy exposes, and the smallest
 * board is the one this kind's simulation was most exhaustively checked
 * against, so a failure -- which the validator's own range should never
 * actually produce -- falls back to it rather than guessing a fix.
 */
export function repairCommandsForGridStrategy(_spec: GridStrategySpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  if (failedReceipt.checks.every((check) => check.passed)) return null;
  return [{ type: "set-params", params: { cols: 4, rows: 4 } }];
}
